import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from '@emotion/styled'

import Section from '../../components/Section'
import Button from '../../components/Button'

import LocationsMapNative from '../../components/native/LocationsMapNative'

import I18n from '../../i18n'

import SearchContextProvider from '../../lib/use-search'
import { MapZoomProvider } from '../../lib/use-map-zoom'

function Locations({
  locations,
  favLocationIds,
  initialQuery,
  locationsCount,
  mapLocations,
  nativeApp
}) {
  return (
    <SearchContextProvider
      locations={locations}
      favLocationIds={favLocationIds}
      initialQuery={initialQuery || ''}
    >
      <MapZoomProvider>
        <Section mid css={{ minHeight: '100%', paddingBottom: '5rem', touchAction: 'none' }}>
          <DataWrapper>
            <LocationsMapNative mapLocations={mapLocations} nativeApp={nativeApp} />
          </DataWrapper>
        </Section>
      </MapZoomProvider>
    </SearchContextProvider>
  )
}

Locations.propTypes = {
  initialQuery: PropTypes.string,
  locations: PropTypes.object.isRequired,
  favLocationIds: PropTypes.array,
  showPartnerBanner: PropTypes.bool,
  mapLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
  locationsCount: PropTypes.number.isRequired,
  showAdvertisingBanner: PropTypes.bool
}

const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
`

const ListWrapper = styled.div`
  width: 35%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  ${p => p.theme.breakpoints.desktop} {
    width: 100%;
  }
`

const ListTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${props => props.theme.chroma.white.hex()};
  border-bottom: 1px solid ${props => props.theme.chroma.grey.hex()};
  padding: 1rem 1rem 1rem 2.5rem;
`

const LocationsCount = styled.div`
  text-transform: uppercase;
  font-weight: bold;
`

export default Locations
